import { render, staticRenderFns } from "./MyPurchases.vue?vue&type=template&id=8e73148a"
import script from "./MyPurchases.vue?vue&type=script&lang=js"
export * from "./MyPurchases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports